module.exports = __webpack_public_path__ + "static/media/cockroach(5).d4bd48c8.PNG";